import { Stack, Typography } from "@mui/material";
import { FC } from "react";

import OrderProductIcon from "../../Misc/OrderProductIcon/order-product-icon";

export type TableCellConfigurationsProps = {
  data: any;
};

const TableCellConfigurations: FC<TableCellConfigurationsProps> = (props) => {
  let distinct =
    props.data === null || props.data === undefined
      ? []
      : props.data.value.filter((n, i) => props.data.value.indexOf(n) === i);

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ svg: { verticalAlign: "middle" } }}>
      {distinct.map((product) => {
        let count =
          props.data === null || props.data === undefined ? 0 : props.data.value.filter((x) => x === product).length;
        return (
          <Typography color="info.main" fontWeight={500} lineHeight="16px" key={product}>
            <OrderProductIcon type={product} color="info" fontSize="small" /> {count}
          </Typography>
        );
      })}
    </Stack>
  );
};

export default TableCellConfigurations;
